// extracted by mini-css-extract-plugin
module.exports = {"button":"Download_button__Mb-gd"};